export default __webpack_public_path__ + "static/media/Tiger.54c726f7.jpg";